// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YlL8","colBig":"styles_colBig__2N__l","colSmall":"styles_colSmall__1qfgs"};